import useTicketStatsQuery from 'src/hooks/services/servicenow/queries/useTicketStatsQuery'

import { IoAlert, IoCheckmark } from 'react-icons/io5'
import { useNavigate } from 'react-router-dom'

import { Tile, TileHeader } from '../Tile'

const MajorIncidentsTile = () => {
  const navigate = useNavigate()
  const { data: ticketStats, isLoading: isTicketStatsLoading } = useTicketStatsQuery({
    groupBy: 'priority',
    stateFilter: ['Open']
  })

  const count = ticketStats?.critical ?? 0
  const textColor = count == 0 ? 'text-th-green' : 'text-th-red'

  return (
    <Tile onMouseDown={() => navigate('/tickets?priority=critical')}>
      <TileHeader loading={isTicketStatsLoading}>
        <TileHeader.Title>
          <span className={`font-headline text-2xl font-bold tracking-wide ${textColor}`}>{count}</span>
        </TileHeader.Title>
        <TileHeader.Subtitle>
          <span className="font-bold tracking-wide text-th-text-secondary">
            {count == 0 ? 'No Major Incidents currently ongoing.' : count == 1 ? 'Major Incident currently ongoing.' : 'Major Incidents currently ongoing.'}
          </span>{' '}
        </TileHeader.Subtitle>
        <TileHeader.Item>{count == 0 ? <IoCheckmark className="h-10 w-10 text-th-green" /> : <IoAlert className="h-10 w-10 text-th-red" />}</TileHeader.Item>
      </TileHeader>
    </Tile>
  )
}

export default MajorIncidentsTile
